import React from "react";
import { MotifFormField, MotifInput, MotifTextArea  } from '@ey-xd/motif-react';
import './InputBox.scss';
import { ltrimString } from "@/utils/common";

type InputBoxType = {
  id?: string | null;
  required?: boolean;
  value: string | number | boolean;
  isTextArea?: boolean;
  onChange: (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => void;
  placeholder?: string;
  type?: "number" | "email" | "text" | "tel" | "date" | "password" | undefined;
  readonly?: boolean;
  disabled?: boolean;
  maxLength?: string;
  onFocus?: (e: any) => void;
  onBlur?: (e: any) => void;
};

const InputBox = React.forwardRef<any, InputBoxType>(function InputBox(
  {
    id,
    type,
    required = false,
    value,
    isTextArea,
    onChange,
    placeholder,
    readonly,
    disabled,
    maxLength,
    onFocus,
    onBlur,
    ...args
  },
  ref
) {
  value = ltrimString(String(value)) || "";
  return (
    <MotifFormField role="group" aria-label={id}>
      {isTextArea ? (
        <MotifTextArea
          {...args}
          id={id}
          ref={ref}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={readonly}
          characterLimit={maxLength ? Number(maxLength) : 1000}
          maxLength={maxLength || "1000"}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      ) : (
        <MotifInput
          type={type}
          hideClearButton={true}
          {...args}
          id={id}
          ref={ref}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled || readonly}
          maxLength={maxLength || "100"}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      )}
    </MotifFormField>
  );
});

export default InputBox;